<template>
  <resource-list-layout :resourceTitle="title">
    <template v-slot:filter>
      <zhb-consult-fitter :fitter="searchObj" @search="handleSearch"></zhb-consult-fitter>
    </template>
    <resource-list-page-content :pageData="pageData" :cols="cols" v-loading="loading"></resource-list-page-content>
  </resource-list-layout>
</template>

<script>
import ResourceListLayout from 'common/ResourceListLayout'
import ResourceListPageContent from 'common/ResourceListPageContent'
import ZhbConsultFitter from './ZhbConsultFitter'
export default {
  name: 'ConsultPage',
  components: {
    ResourceListLayout,
    ResourceListPageContent,
    ZhbConsultFitter
  },
  data () {
    return {
      title: '工厂需求对接',
      loading: false,
      pageData: [],
      cols: [
        { label: '编号', prop: 'id' },
        { label: '手机号', prop: 'mobile' },
        { label: '公司名称', prop: 'company_name' },
        { label: '咨询内容', prop: 'content', isNowrap: true },
        { label: '类型', prop: 'type_desc' },
        { label: '预约时间', prop: 'appointment_time', width: 170 },
        { label: '创建时间', prop: 'created_at', width: 170 }
      ],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1,
        pageSize: 30, // 每页显示条数
      },
      searchObj: {
        mobile: '',
        type: ''
      },
      mobileChange: false
    }
  },
  provide () {
    return {
      pageOption: this.pageOption
    }
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchObj) {
        str += "&" + key + "=" + this.searchObj[key]
      }
      return str
    }
  },
  watch: {
    'pageOption.currentPage': {
      handler (newVal) {
        this.fetchData()
      }
    },
    'pageOption.pageSize': {
      handler (newVal) {
        this.fetchData()
      }
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      this.$axios.get('/api/admin/Zhb/consults?page=' + this.pageOption.currentPage + '&pageSize=' + this.pageOption.pageSize + this.searchStr, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.pageData = data.data.data
            this.pageOption.total = data.data.total
            this.loading = false
            this.mobileChange = false
          }
        })
    },
    handleSearch (search) {
      if (this.mobileChange) return
      this.mobileChange = true
      setTimeout(() => {
        if (this.pageOption.currentPage === 1) {
          this.fetchData()
          return
        }
        this.pageOption.currentPage = 1
      }, 600)
    }
  },
  mounted () {
    this.fetchData()
  }
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/zhb_consult/ConsultPage.vue